import { historyVersionsTabActions } from '../actions'
import { VERSION_PREVIEW_LIMIT } from '../constants'
import {
    formatHistoryDate,
    formatTableCellValue,
    getPreviewColumns,
} from '../utils/historyHelpers'
import { useActions, useAppSelector } from '../../../store/hooks'
import { historyPageSelector } from '../../../store/slices/historyPage'
import { historySelector } from '../../../store/slices/history'

export function useHistoryVersionsTab() {
    const versions = useAppSelector(historySelector.versions)
    const maxVersions = useAppSelector(historySelector.maxVersions)
    const versionsLoading = useAppSelector(historySelector.versionsLoading)
    const versionsError = useAppSelector(historySelector.versionsError)
    const versionData = useAppSelector(historySelector.versionData)
    const versionDataLoading = useAppSelector(historySelector.versionDataLoading)
    const versionDataError = useAppSelector(historySelector.versionDataError)
    const activeVersion = useAppSelector(historyPageSelector.activeVersion)
    const activeVersionId = useAppSelector(historyPageSelector.activeVersionId)
    const versionTable = useAppSelector(historyPageSelector.versionTable)

    const {
        openVersion,
        closeVersion,
        setVersionTable,
        historyLoadVersionData,
        resetVersionData,
        resetVersionDataError,
    } = useActions(historyVersionsTabActions)

    const previewRows = versionData.slice(0, VERSION_PREVIEW_LIMIT)
    const previewColumns = getPreviewColumns(previewRows)

    const handleViewVersion = (version) => {
        if (activeVersionId === version.version_id) {
            closeVersion()
            resetVersionData([])
            resetVersionDataError(null)
            return
        }

        openVersion({ versionId: version.version_id })
        historyLoadVersionData({ versionId: version.version_id, table: 'classes' })
    }

    const handleChangeVersionTable = (table) => {
        setVersionTable(table)

        if (activeVersionId) {
            historyLoadVersionData({ versionId: activeVersionId, table })
        }
    }

    return {
        versions,
        maxVersions,
        versionsLoading,
        versionsError,
        versionData,
        versionDataLoading,
        versionDataError,
        activeVersion,
        activeVersionId,
        versionTable,
        previewRows,
        previewColumns,
        formatDate: formatHistoryDate,
        formatCellValue: formatTableCellValue,
        handleViewVersion,
        handleChangeVersionTable,
    }
}
